import React, { FC } from 'react'

import { IconSolutionFinderProps } from './IconSolutionFinder.types'
import * as Styled from './styles/IconSolutionFinder.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSolutionFinder: FC<IconSolutionFinderProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSolutionFinderProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconSolutionFinderProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M39.13 73.38A4 4 0 1 0 33.47 79l35.7 35.8A4 4 0 0 0 72 116a4 4 0 0 0 2.83-1.17l80.5-80.5a4 4 0 0 0-5.66-5.66L72 106.34z' />
        <path d='M157.16 58.84a4 4 0 1 0-7.72 2.16 72 72 0 0 1-105.09 81.57 72 72 0 1 1 82.27-117.51 4 4 0 1 0 5.16-6.11 80.15 80.15 0 1 0 25.38 39.9z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSolutionFinder
